import axios from "axios"
import * as api from "../api/soporte.api"

export default class SoporteService {
    getConfig = () => {
        const token = sessionStorage.getItem("token") || ""
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    list = async ({ entity, status = "on", filters = {}, limit = 100, offset = 0, orderBy = "id", orderDir = "DESC" }) => {
        try {
            const response = await axios.post(
                api.list,
                { entity, status, filters, limit, offset, orderBy, orderDir },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al listar", error }
        }
    }

    getOne = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.getOne, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al consultar", error }
        }
    }

    create = async ({ entity, data }) => {
        try {
            let payloadData = data
            if (entity === "tickets") {
                const { solicitante_nombre, cliente_nombre, ...rest } = payloadData
                payloadData = {
                    ...rest,
                    ...(solicitante_nombre ? { nombre_solicitante: solicitante_nombre } : {}),
                    ...(cliente_nombre ? { nombre_cliente: cliente_nombre } : {}),
                }
            }
            const response = await axios.post(api.create, { entity, data: payloadData }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al crear", error }
        }
    }

    update = async ({ entity, id, data, actor_user_id }) => {
        try {
            const response = await axios.post(
                api.update,
                { entity, id, data, actor_user_id },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al actualizar", error }
        }
    }

    remove = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.remove, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al eliminar", error }
        }
    }

    desactivate = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.desactivate, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al desactivar", error }
        }
    }

    activate = async ({ entity, id }) => {
        try {
            const response = await axios.post(api.activate, { entity, id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al activar", error }
        }
    }

    ticketAssign = async (payload) => {
        try {
            const response = await axios.post(api.ticketAssign, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al asignar ticket", error }
        }
    }

    ticketChangeStatus = async (payload) => {
        try {
            const response = await axios.post(api.ticketChangeStatus, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cambiar estado", error }
        }
    }

    ticketClose = async (payload) => {
        try {
            const response = await axios.post(api.ticketClose, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cerrar ticket", error }
        }
    }

    ticketReopen = async (payload) => {
        try {
            const response = await axios.post(api.ticketReopen, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al reabrir ticket", error }
        }
    }

    ticketEscalate = async (payload) => {
        try {
            const response = await axios.post(api.ticketEscalate, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al escalar ticket", error }
        }
    }

    listNotifications = async ({ limit = 25, only_unread = false } = {}) => {
        try {
            const response = await axios.post(
                api.notificationsList,
                { limit, only_unread },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar notificaciones", error }
        }
    }

    markNotificationRead = async ({ notification_id }) => {
        try {
            const response = await axios.post(
                api.notificationsRead,
                { notification_id },
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al marcar notificación", error }
        }
    }

    markAllNotificationsRead = async () => {
        try {
            const response = await axios.post(
                api.notificationsReadAll,
                {},
                this.getConfig()
            )
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al marcar notificaciones", error }
        }
    }

    // ─── Parámetros de tickets ────────────────────────────────────────────
    getTicketModulos = async () => {
        try {
            const response = await axios.get(api.ticketModulos, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar módulos", error }
        }
    }

    getTicketEstados = async () => {
        try {
            const response = await axios.get(api.ticketEstados, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar estados", error }
        }
    }

    getTicketTiposContacto = async () => {
        try {
            const response = await axios.get(api.ticketTiposContacto, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar tipos de contacto", error }
        }
    }

    getTicketPrioridades = async () => {
        try {
            const response = await axios.get(api.ticketPrioridades, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar prioridades", error }
        }
    }

    getTicketSolicitudes = async () => {
        try {
            const response = await axios.get(api.ticketSolicitudes, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar solicitudes", error }
        }
    }

    getTicketEscalationUsers = async (grupoId = null) => {
        try {
            const url = grupoId
                ? `${api.ticketEscalationUsers}?grupo_id=${encodeURIComponent(grupoId)}`
                : api.ticketEscalationUsers
            const response = await axios.get(url, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar usuarios para escalado", error }
        }
    }

    getTicketClientesPagados = async () => {
        try {
            const response = await axios.get(api.ticketClientesPagados, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar clientes pagados", error }
        }
    }

    getTicketClientUsers = async (clienteId) => {
        try {
            const response = await axios.get(`${api.ticketClientesBase}/${clienteId}/usuarios`, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar solicitantes del cliente", error }
        }
    }

    getClientes = async () => {
        try {
            const response = await axios.get(api.clientes, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar clientes", error }
        }
    }

    getInventoryUsers = async () => {
        try {
            const response = await axios.get(api.inventoryUsers, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar usuarios de inventario", error }
        }
    }

    downloadInventoryTemplate = async () => {
        return axios.get(api.inventoryTemplate, {
            ...this.getConfig(),
            responseType: "blob"
        })
    }

    exportInventory = async () => {
        return axios.get(api.inventoryExport, {
            ...this.getConfig(),
            responseType: "blob"
        })
    }

    importInventory = async (file) => {
        const form = new FormData()
        form.append("upload", file)
        try {
            const response = await axios.post(api.inventoryImport, form, {
                ...this.getConfig(),
                headers: {
                    ...this.getConfig().headers,
                    "Content-Type": "multipart/form-data"
                }
            })
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al importar inventario", error }
        }
    }

    // ─── Configuración técnica por cliente (cliente_conexion) ─────────────
    getClienteConexionConfig = async (payload) => {
        try {
            const response = await axios.post(api.clienteConexionConfigGet, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al cargar la configuración del cliente", error }
        }
    }

    saveClienteConexionConfig = async (payload) => {
        try {
            const response = await axios.post(api.clienteConexionConfigSave, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al guardar la configuración del cliente", error }
        }
    }

    // ─── Conexiones (MongoDB) ───────────────────────────────────────────────
    listConexiones = async () => {
        try {
            const response = await axios.get(api.conexionesList, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al listar conexiones", error }
        }
    }

    getConexionOne = async ({ id }) => {
        try {
            const response = await axios.post(api.conexionesGetOne, { id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al consultar la conexión", error }
        }
    }

    createConexion = async (data) => {
        try {
            const response = await axios.post(api.conexionesCreate, data, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al crear la conexión", error }
        }
    }

    updateConexion = async ({ id, ...data }) => {
        try {
            const response = await axios.post(api.conexionesUpdate, { id, ...data }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al actualizar la conexión", error }
        }
    }

    deleteConexion = async ({ id }) => {
        try {
            const response = await axios.post(api.conexionesDelete, { id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al eliminar la conexión", error }
        }
    }

    // Ejecuta un script SQL en las bases MySQL de los clientes (solo admin).
    // body: { nombre, script | script_id, todas | proyectos, password, confirmado }
    executeScriptConexiones = async (data) => {
        try {
            const response = await axios.post(api.conexionesExecuteScript, data, this.getConfig())
            return response.data
        } catch (error) {
            // Los 4xx/5xx del endpoint traen `resumen: null`, `data: []` y `novedades`
            // para mostrarse con el mismo componente, así que se conserva el body.
            const body = error?.response?.data
            return {
                ...(body && typeof body === "object" ? body : {}),
                success: false,
                message: body?.message || "Error al ejecutar el script",
                error,
            }
        }
    }

    // Historial de scripts ejecutados (solo admin). body: { buscar, limit, skip }
    listScriptsEjecutados = async ({ buscar = "", limit = 50, skip = 0 } = {}) => {
        try {
            const payload = { limit, skip, ...(buscar ? { buscar } : {}) }
            const response = await axios.post(api.conexionesScriptsList, payload, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al listar el historial de scripts", error }
        }
    }

    // Detalle de una ejecución: script completo + bases donde ya se aplicó.
    getScriptEjecutado = async ({ id }) => {
        try {
            const response = await axios.post(api.conexionesScriptsGet, { id }, this.getConfig())
            return response.data
        } catch (error) {
            return { success: false, message: error?.response?.data?.message || "Error al consultar el script", error }
        }
    }
}
